<div>
  <ng-container *ngIf="scrollService.isMobile$ | async">
    <app-mobile-toolbar
      (homeClicked)="linkClicked($event)"
      (openMobileMenu)="openMobileMenu()"
    ></app-mobile-toolbar>
  </ng-container>
  <ng-container *ngIf="!(scrollService.isMobile$ | async)">
    <app-toolbar (linkClicked)="linkClicked($event)"></app-toolbar>
  </ng-container>

  <div class="intro-section">
    <div class="introducing">INTRODUCING</div>
    <div class="title">Manual Read App</div>
    <div class="subtitle">Better Reads. Fewer Headaches.</div>
    <div class="phone-container">
      <img src="/assets/manual-read-app/manual-read-app-phones.png" />
    </div>
  </div>
  <div class="modernize-section">
    <p class="description">
      Manual Rad App <span class="emphasize">simplifies data collection</span>,
      <span class="emphasize">ensures accuracy</span>, and
      <span class="emphasize">improves oversight</span>, making every read
      <span class="emphasize">accountable</span>.
    </p>
    <a
      target="_blank"
      href="https://support.nextcenturymeters.com/hc/en-us/articles/360045859172-How-to-use-the-Manual-Read-App"
      class="learn-more"
      >LEARN MORE</a
    >
    <div class="laptop-container">
      <img src="/assets/manual-read-app/mra-laptop.png" />
    </div>
    <div class="modernize">Modernize Manual Reads</div>
    <table class="modernize-table">
      <tr class="modernize-item">
        <td>
          <i class="icon-camera"></i>
        </td>
        <td>
          <div class="item-header">Photo-Verified Reads</div>
          <div class="item-description">
            Readers can take a photo with each entry.
          </div>
        </td>
      </tr>
      <tr class="modernize-item">
        <td>
          <i class="icon-map-pin"></i>
        </td>
        <td>
          <div class="item-header">GPS-Stamped Submissions</div>
          <div class="item-description">
            Recorded GPS location adds context to every read.
          </div>
        </td>
      </tr>
      <tr class="modernize-item">
        <td>
          <i class="icon-mic"></i>
        </td>
        <td>
          <div class="item-header">Speech-To-Text Input</div>
          <div class="item-description">
            Enter meter reads hands-free using voice input.
          </div>
        </td>
      </tr>
      <tr class="modernize-item">
        <td>
          <i class="icon-edit-3"></i>
        </td>
        <td>
          <div class="item-header">Built-In Notes</div>
          <div class="item-description">
            Provide important notes for every read.
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="why-section">
    <div class="why-title">Why Choose Manual Read App?</div>
    <table>
      <tr>
        <td>
          <div><i class="icon-alert-triangle"></i></div>
          <div>Prevent Billing Issues</div>
        </td>
        <td>
          <div><i class="icon-star"></i></div>
          <div>Ensure Accuracy</div>
        </td>
      </tr>
      <tr>
        <td>
          <div><i class="icon-property"></i></div>
          <div>Improve Organization</div>
        </td>
        <td>
          <div><i class="icon-monitor"></i></div>
          <div>Simplify Records</div>
        </td>
      </tr>
    </table>
  </div>
  <div class="smart-section">
    <div class="smart-title">
      Smart, Secure, and<br />
      Cost-Effective
    </div>
    <div class="content-container">
      <table>
        <tr>
          <td>
            <div class="smart-item-header">TRANSPARENCY</div>
            <div class="smart-item-description">
              Confirm the validity of every meter read.
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="smart-item-header">ACCURACY</div>
            <div class="smart-item-description">
              Track every submission with timestamps and documentation.
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="smart-item-header">UNIFIED REPORTS</div>
            <div class="smart-item-description">
              Manage AMR and Manual Reads in the same system.
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="smart-item-header">RELIABLE DATA</div>
            <div class="smart-item-description">
              Verify with Photo & GPS for more trustworthy readings.
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="smart-item-header">OVERSIGHT</div>
            <div class="smart-item-description">
              Monitor reader performance and catch errors early.
            </div>
          </td>
        </tr>
      </table>
      <div class="phone-container">
        <img src="/assets/manual-read-app/mra-enter-read.png" />
      </div>
    </div>
  </div>
  <div class="learn-more-section">
    <p>
      Increase <span class="emphasize">accountability</span>,
      <span class="emphasize">accuracy</span>, and
      <span class="emphasize">efficiency</span> to your manual read process with
      the <span class="emphasize">Manual Read App</span>.
    </p>
    <a
      target="_blank"
      href="https://support.nextcenturymeters.com/hc/en-us/articles/360045859172-How-to-use-the-Manual-Read-App"
      class="learn-more-button-white"
      >LEARN MORE</a
    >
  </div>

  <ng-container *ngIf="scrollService.isMobile$ | async">
    <app-mobile-footer></app-mobile-footer>
  </ng-container>
  <ng-container *ngIf="!(scrollService.isMobile$ | async)">
    <app-footer id="footer" (linkClicked)="linkClicked($event)"></app-footer>
  </ng-container>
</div>
